module.exports = __webpack_public_path__ + "static/media/data-demo.456ddc2c.xls";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data-demo.xls
// module id = 784
// module chunks = 0